module.exports = __webpack_public_path__ + "img/9791159312526.0877142a.jpg";